import { c as _c } from "react/compiler-runtime";
import { styled } from '@classify/react-core-components/styles';
import Paper from '@mui/material/Paper';
import MenuList from '@mui/material/MenuList';
import Divider from '@classify/react-core-components/Divider';
import Typography from '@classify/react-core-components/Typography';
import { translate } from '@openclassrooms/translations';
import { ROUTES, getButtonLinkProps } from '@openclassrooms/routing';
import MenuItem from './MenuItem';
const MenuItemStyled = styled(MenuItem)({
  '& .MuiListItemText-inset': {
    paddingLeft: 0
  }
});
const SectionTitle = styled(Typography)(({
  theme: {
    spacing,
    palette
  }
}) => ({
  margin: spacing(1, 1, 1, 2),
  color: palette.text.secondary
})) as typeof Typography;
export default function MainHeaderVisitorMenu() {
  const $ = _c(8);
  const isNextJsDev = process.env.APP_TYPE === "nextjs" && process.env.NODE_ENV === "development";
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <MenuItemStyled {...getButtonLinkProps(ROUTES.AUTH.LOGIN)} label={translate("main_header.create_account")} data-event="Navigation|Redirection::Internal|Header account creation" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <MenuItemStyled {...getButtonLinkProps(isNextJsDev ? "/dev/login" : ROUTES.AUTH.LOGIN)} label={translate("main_header.login")} data-event="Navigation|Redirection::Internal|Header login" />;
    t2 = <Divider />;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SectionTitle variant="overline">{translate("main_header.students")}</SectionTitle>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <MenuItemStyled {...getButtonLinkProps(ROUTES.APPLICATION.INDEX)} label={translate("global.apply.cta")} data-event="Navigation|Redirection::Internal|Header apply" />;
    t5 = <Divider />;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <SectionTitle variant="overline">{translate("main_header.employer")}</SectionTitle>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Paper elevation={8}><MenuList id="main-header-menu">{t0}{t1}{t2}{t3}{t4}{t5}{t6}<MenuItemStyled {...getButtonLinkProps(ROUTES.MY_ORGANIZATION.OVERVIEW)} label={translate("global.word.access_employer_space")} data-event="Navigation|Redirection::Internal|Header employer space" /></MenuList></Paper>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  return t7;
}